import { render, staticRenderFns } from "./RegisterTransferMedical.vue?vue&type=template&id=fc673c2a&scoped=true&"
import script from "./RegisterTransferMedical.vue?vue&type=script&lang=ts&"
export * from "./RegisterTransferMedical.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterTransferMedical.vue?vue&type=style&index=0&id=fc673c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc673c2a",
  null
  
)

export default component.exports